// KindPills.tsx — New/Existing pill row + conditional scope pills + locked
// hint. Pills are MUI ToggleButtonGroup (team standard) styled to the design
// (newproduct-v6.jsx pill row).
import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { ProductKind, FeatureScope } from "./state";

const pillSx = {
    border: "none",
    borderRadius: "999px !important",
    padding: "5px 14px",
    fontSize: "11.5px",
    fontWeight: 600,
    lineHeight: 1.5,
    textTransform: "none",
    whiteSpace: "nowrap",
    fontFamily: "inherit",
    background: "var(--bg-input)",
    color: "var(--fg3)",
    "&:hover": { background: "var(--bg-input)" },
    "&.Mui-selected": {
        background: "var(--np-brand)",
        color: "#fff",
        "&:hover": { background: "var(--np-brand-hover)" }
    }
} as const;

export function KindPills({
    kind,
    scope,
    locked,
    onKind,
    onScope,
    onCancel
}: {
    kind: ProductKind | null;
    scope: FeatureScope | null;
    locked: boolean;
    onKind: (k: ProductKind) => void;
    onScope: (s: FeatureScope) => void;
    onCancel: () => void;
}) {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
            <ToggleButtonGroup
                exclusive
                value={kind}
                onChange={(_, v: ProductKind | null) => v && onKind(v)}
                sx={{ gap: "10px", "& .MuiToggleButtonGroup-grouped": { margin: 0 } }}
            >
                <ToggleButton disableRipple value="new" sx={pillSx}>
                    New Product
                </ToggleButton>
                <ToggleButton disableRipple value="existing" sx={pillSx}>
                    Add To Existing Product
                </ToggleButton>
            </ToggleButtonGroup>
            {kind === "existing" && (
                <>
                    <span style={{ width: 1, height: 20, background: "var(--divider)", margin: "0 4px" }} />
                    <ToggleButtonGroup
                        exclusive
                        value={scope}
                        onChange={(_, v: FeatureScope | null) => v && onScope(v)}
                        sx={{ gap: "10px", "& .MuiToggleButtonGroup-grouped": { margin: 0 } }}
                    >
                        <ToggleButton disableRipple value="single" sx={pillSx}>
                            Single Feature
                        </ToggleButton>
                        <ToggleButton disableRipple value="multi" sx={pillSx}>
                            Multiple Features
                        </ToggleButton>
                    </ToggleButtonGroup>
                </>
            )}
            {locked && (
                <span
                    onClick={onCancel}
                    style={{
                        whiteSpace: "nowrap",
                        fontSize: 11.5,
                        fontWeight: 600,
                        padding: "5px 14px",
                        borderRadius: 999,
                        cursor: "pointer",
                        background: "var(--bg-paper)",
                        border: "1px solid var(--divider)",
                        color: "var(--fg3)"
                    }}
                >
                    Cancel
                </span>
            )}
            {locked && (
                <span style={{ fontSize: 11.5, fontWeight: 650, color: "var(--np-brand)" }}>
                    {"←"} {kind === "existing" ? "Single or Multiple Features? Pick one to unlock the form" : "Pick one to unlock the form"}
                </span>
            )}
        </div>
    );
}
